import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCloseHeavyRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	viewBox: "0 0 32 32",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M9.156 6.87A1.602 1.602 0 0 0 6.89 9.135L13.76 16l-6.865 6.87a1.602 1.602 0 0 0 2.265 2.265l6.865-6.87 6.87 6.865a1.602 1.602 0 0 0 2.265-2.265L18.29 16l6.865-6.87a1.602 1.602 0 0 0-2.265-2.265l-6.865 6.87z" })
});
export default SvgCloseHeavyRegularIcon;
